import { asBoolean, optionalEnum, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.consultation.dto.EncounterType
 */
export const EncounterType = Object.freeze({
  FACE_TO_FACE: 'FACE_TO_FACE',
  TELEPHONE: 'TELEPHONE',
});

/**
 * Mirrors com.medprompt.consultation.ConsultationDetails
 *
 * @typedef {object} ConsultationDetailsData
 * @property {string|null} encounterType
 * @property {boolean} isHiddenFromPatient
 */

/**
 * @param {object} raw
 * @returns {ConsultationDetailsData}
 */
export function fromConsultationDetailsData(raw) {
  const source = requireObject(raw, 'ConsultationDetails');
  return {
    encounterType: optionalEnum(source.encounterType, EncounterType, 'ConsultationDetails', 'encounterType'),
    isHiddenFromPatient: asBoolean(source.isHiddenFromPatient),
  };
}
